<template>
	<div>
		<!-- 主体内容 -->
		<div class="main-container">
			<img class="logo" v-if="isDoctor" src="../../assets/images/logo-doctor.png" />
			<img class="logo" v-else src="../../assets/images/logo.png" />
			<div class="app-core">
				<div class="name">亮健康{{isDoctor ? '医生' : ''}}</div>
				<div class="version">版本号：v1.0</div>
			</div>
			<div class="app-desc">大健康领域短视频专业平台</div>
			<div class="app-contact">
				<div class="title">联系我们</div>
				<div class="info">
					<div class="key">全国服务热线：</div>
					<a class="value" href="tel:400-0183-082">400-0183-082</a>
				</div>
				<div class="info">
					<div class="key">官网：</div>
					<a class="value" href="https://www.360lj.com" target="_blank">https://www.360lj.com</a>
				</div>
			</div>
		</div>

		<!-- 页脚版权 -->
		<div class="footer">Copyright © 湖南亮健优医易问网络科技有限公司</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isDoctor: false
		}
	},
	created() {
		const type = this.$route.params.type;
		this.isDoctor = type && type == 'doctor';
		
		document.title = '关于我们';
	}
};
</script>

<style lang="scss" scoped>
.main-container {
	margin: 100px auto;
	font-size: 12px;
	text-align: center;

	.logo {
		width: 130px;
		height: 130px;
	}

	.app-core {
		margin-top: 10px;
		color: #999999;
		line-height: 22px;
		
		.name {
			color: rgb(35,213,224);
			font-size: 15px;
			font-weight: bold;
		}
	}
	
	.app-desc {
		color: #333;
		margin: 20px auto;
		font-size: 16px;
	}
	
	.app-contact {
		line-height: 22px;
		margin-top: 40px;
		
		.title {
			font-size: 14px;
			color: #999999;
			position: relative;
			
			&::after, &::before {
				position: absolute;
				top: 50%;
				width: 35%;
				content: '';
				height: 1px;
				background-color: #f1f1f1;
			}
			
			&::after {
				left: 20px;
			}
			
			&::before {
				right: 20px;
			}
		}
		
		.info {
			margin-top: 15px;
			color: #999;
			display: flex;
			justify-content: center;
			
			.value {
				color: #007aff;
			}
		}
	}
}

.footer {
	color: #797979;
	font-size: 12px;
	position: fixed;
	bottom: 20px;
	left: 0;
	right: 0;
	text-align: center;
}
</style>
